import React, { FC } from 'react';
import Button from '@this/template/components/bootstrap/Button';
import Spinner from '@this/template/components/bootstrap/Spinner';
import { toast } from 'react-toastify';
import Toasts from '@this/template/components/bootstrap/Toasts';
import api from '@this/impl/api';

interface FavoriteButtonProps {
	documentId: string;
	isFavorite: boolean;
	size?: 'sm' | 'lg' | undefined;
	className?: string;
	showLabel?: boolean;
	disabled?: boolean;
}

const FavoriteButton: FC<FavoriteButtonProps> = ({
	documentId,
	isFavorite,
	size,
	className = '',
	showLabel = false,
	disabled = false,
}) => {
	const toggleFavoriteMutation = api.Contents.useToggleDocumentFavorite();

	const handleToggleFavorite = async () => {
		try {
			await toggleFavoriteMutation.mutateAsync({
				documentId,
				favorite: !isFavorite,
			});

			toast(
				<Toasts
					title={isFavorite ? 'Favorito removido' : 'Favorito agregado'}
					icon={isFavorite ? 'StarBorder' : 'Star'}
					iconColor={isFavorite ? 'secondary' : 'warning'}>
					{isFavorite
						? 'Documento removido de favoritos'
						: 'Documento agregado a favoritos'}
				</Toasts>,
				{ autoClose: 2000 },
			);
		} catch (error) {
			toast(
				<Toasts title='Error' icon='Error' iconColor='danger'>
					Error al actualizar favoritos
				</Toasts>,
				{ autoClose: 3000 },
			);
		}
	};

	return (
		<Button
			size={size}
			color={isFavorite ? 'warning' : 'light'}
			isLight={!isFavorite}
			className={className}
			onClick={handleToggleFavorite}
			isDisable={disabled || toggleFavoriteMutation.isLoading}
			title={isFavorite ? 'Remover de favoritos' : 'Agregar a favoritos'}>
			{toggleFavoriteMutation.isLoading ? <Spinner isSmall inButton /> : <span>★</span>}
			{showLabel && (
				<span className='ms-1'>{isFavorite ? 'Favorito' : 'Agregar a favoritos'}</span>
			)}
		</Button>
	);
};

export default FavoriteButton;
